import { GA4_MEASUREMENT_ID } from "./site.config";

type GtagFn = (...args: any[]) => void;

function gtagAvailable(): boolean {
  return typeof (window as any).gtag === "function";
}

export function ga4MeasurementId(): string {
  return GA4_MEASUREMENT_ID;
}

export function ga4PageView(pagePath: string): void {
  const id = ga4MeasurementId();
  if (!id) return;
  if (!gtagAvailable()) return;
  const gtag = (window as any).gtag as GtagFn;
  gtag("config", id, { page_path: pagePath });
}

